import Lenis from '@studio-freight/lenis';
import { SCROLL } from '../app.config.js';
export default class Scroller {

  constructor() {
    SCROLL && this.init();
  }

  init() {

    this.setFilters();

    //init lenis
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      this.lenis.raf(time);
      requestAnimationFrame(raf.bind(this));
    }

    requestAnimationFrame(raf.bind(this));

    this.lenis.on('scroll', ({ scroll }) => {
      if (scroll > 120) {
        document.body.classList.add('_scrolled')
      } else {
        document.body.classList.remove('_scrolled')
      }
    });
  }

  start() {
    this.lenis.start();
  }

  stop() {
    this.lenis.stop();
  }

  toggle() {
    this.lenis.isStopped ? this.lenis.start() : this.lenis.stop();
  }

  scrollTo(n, immediate) {
    this.lenis.scrollTo(n, { immediate: immediate });
  }

  setFilters() {
    //A hack has been added to fix the filters on the desktop. The hack has been implemented to prevent issues on desktop due to a strange behavior when hovering over the filters toolbar.
    const filters = document.querySelector('[data-filters]');
    const mq = '(max-width:1440px)';
    const mqList = window.matchMedia(mq);

    if (filters && mqList.matches === true) {
      filters.setAttribute('data-lenis-prevent', '')
    }
  }
}
